import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-admin-detail',
  templateUrl: './admin-detail.component.html',
  styleUrls: ['./admin-detail.component.css']
})
export class AdminDetailComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  personalDetailForm: FormGroup;
  registerId: any;
  getPersonalData: any;
  checkIfUserAlreadyExist = false;
  confirmPasswordCheck = false;
  minDate: any;
  maxDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private commonUtilService: CommonUtilService,
    public datepipe: DatePipe,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {

    this.spinnerService.start();
    
    var today = new Date();
    this.maxDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 20), 'yyyy-MM-dd');
    this.minDate = this.datepipe.transform(today.setFullYear(today.getFullYear() - 55), 'yyyy-MM-dd'); 

    this.commonUtilService.translateLang('HRWE.REGISTRATION.PERSONAL-DETAIL.TITLE');

    this.personalDetailForm = this.personalDetailFormBuilder(this.formBuilder);

    this.getDetail();

  }

  getDetail(){
    this.userService.getAdminDetail().subscribe(data => {
      console.log(data);
      this.getPersonalData = data;
      this.personalDetailForm = this.personalDetailFormBuilder(this.formBuilder);
      this.spinnerService.stop();
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.personalDetailForm.controls; }
  // convenience getter for easy access to form fields
  get val() { return this.personalDetailForm.value; }

  // form builder service create form group instances
  personalDetailFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      firstName: [this.getPersonalData && this.getPersonalData.firstName ? this.getPersonalData.firstName : '', [Validators.required]],
      lastName: [this.getPersonalData && this.getPersonalData.lastName ? this.getPersonalData.lastName : '', [Validators.required]],
      fiscalCode: [this.getPersonalData && this.getPersonalData.fiscalCode && this.getPersonalData.fiscalCode.value ? this.getPersonalData.fiscalCode.value : '', [Validators.required, Validators.pattern('^[A-Za-z0-9]{16}$')]],
      dateOfBirth: [this.getPersonalData && this.getPersonalData.dateOfBirth ? this.datepipe.transform(this.getPersonalData.dateOfBirth, 'yyyy-MM-dd') : '', [Validators.required]],
      cityOfBirth: [this.getPersonalData && this.getPersonalData.cityOfBirth ? this.getPersonalData.cityOfBirth : '', [Validators.required]],
      countryOfBirth: [this.getPersonalData && this.getPersonalData.countryOfBirth ? this.getPersonalData.countryOfBirth : '', [Validators.required]],
      personalResidenceVia: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.street ? this.getPersonalData.address.street : '', [Validators.required]],
      personalResidenceNCivic: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.houseNumber ? this.getPersonalData.address.houseNumber : '', [Validators.required]],
      personalResidenceCity: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.city ? this.getPersonalData.address.city : '', [Validators.required]],
      personalResidenceProvince: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.district ? this.getPersonalData.address.district : '', [Validators.required]],
      personalResidenceCountry: [this.getPersonalData && this.getPersonalData.address && this.getPersonalData.address.country ? this.getPersonalData.address.country : '', [Validators.required]],
      telephoneNumberPrefix: [this.getPersonalData && this.getPersonalData.phoneNumber && this.getPersonalData.phoneNumber.countryCode ? this.getPersonalData.phoneNumber.countryCode : '', [Validators.pattern('^[+]?[0-9]{2,4}$')]],
      telephoneNumber: [this.getPersonalData && this.getPersonalData.phoneNumber && this.getPersonalData.phoneNumber.number ? this.getPersonalData.phoneNumber.number : '', [Validators.required, Validators.pattern('^[0-9]{10}$')]]
    });
  }

  onSubmit() {
    this.spinnerService.start();
    this.success = false;
    this.error = false;
    this.submitted = true;

    if (this.personalDetailForm.invalid) {

      this.commonUtilService.findInvalidControls(this.personalDetailForm);
      this.spinnerService.stop();
      return;
    }

    var personalDetail = {
      firstName: this.val.firstName,
      lastName: this.val.lastName,
      fiscalCode: {
        value: this.val.fiscalCode
      },
      dateOfBirth: this.val.dateOfBirth,
      cityOfBirth: this.val.cityOfBirth,
      countryOfBirth: this.val.countryOfBirth,
      address: {
        street: this.val.personalResidenceVia,
        houseNumber: this.val.personalResidenceNCivic,
        city: this.val.personalResidenceCity,
        district: this.val.personalResidenceProvince,
        country: this.val.personalResidenceCountry
      },
      phoneNumber: {
        countryCode: this.val.telephoneNumberPrefix,
        number: this.val.telephoneNumber
      }
    };

    this.userService.updateAdminDetail(personalDetail).subscribe(data => {
      this.success = true;
      this.spinnerService.stop();
      setTimeout(()=>{                           
        location.reload();
      }, 3000);
    }, err => {
     this.error = true;
      this.spinnerService.stop(); 
      setTimeout(()=>{                           
        this.error = false;
      }, 2000);
    });
  }

  resetForm(){
    this.spinnerService.start();
    this.getDetail();
  }

}
